import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const HISTORIQUEPAIE_URL = `${backendUrl}/api/historiquepaiement/`;

class HistoriquepaiementService {
	async getAllHistoriquepaiements() {
		try {
			const response = await axios.get(HISTORIQUEPAIE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getHistoriquepaiement(id) {
		return axios.get(`${HISTORIQUEPAIE_URL}${id}/`);
	}

	createHistoriquepaiement(data) {
		return axios.post(HISTORIQUEPAIE_URL, data);
	}

	updateHistoriquepaiement(id, data) {
		return axios.put(`${HISTORIQUEPAIE_URL}${id}/`, data);
	}

	deleteHistoriquepaiement(id) {
		return axios.delete(`${HISTORIQUEPAIE_URL}${id}/`);
	}

	getHistoriquepaiementNames(personelIds) {
		return axios.get(`${HISTORIQUEPAIE_URL}?personelIds=${personelIds}`);
	}

	getHistoriquepaiementOptions() {
		return this.getAllHistoriquepaiements().then((Historiquepaiements) => {
			const options = Historiquepaiements.map((Historiquepaiement) => ({
				value: Historiquepaiement.id,
				label: Historiquepaiement.eleve.toUpperCase()
			}));
			// options.unshift({value: null, label: 'Selectionner la salle de Historiquepaiement'});
			return options;
		});
	}
}

export default new HistoriquepaiementService();
